var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAspectRatioSquarePopover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    fill: "#121212",
    stroke: "#898E93"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAspectRatioSquarePopover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aspect-ratio-square-popover.75c4c01a5cd23953e8c165c6162bd950.svg";